import request from "@/utils/request.js"

const dept = {
    list: params => request.get("/api/System/Organize/Depts", { params }),
    submit: params => request.post("/api/System/Organize/SaveDept", params),
    delete: params => request.get("/api/System/Organize/DeleteDept", { params })
}

const staff = {
    list: params => request.post("/api/System/Organize/Staffs", params),
    submit: params => request.post("/api/System/Organize/SaveStaff", params),
    delete: params => request.get("/api/System/Organize/DeleteStaff", { params })
}

const customer = {
    list: params => request.post("/api/System/Customer/GetList", params),
    info: params => request.get("/api/System/Customer/GetInfo", { params }),
    submit: params => request.post("/api/System/Customer/Submit", params),
    delete: params => request.get("/api/System/Customer/Delete", { params }),
    user: {
        list: params => request.post("/api/System/Customer/GetUsers", params),
        insert: params => request.get("/api/System/Customer/Binding", { params }),
        delete: params => request.get("/api/System/Customer/Unbound", { params }),
    },
    man: {
        list: params => request.get("/api/System/Customer/GetMans", { params }),
        insert: params => request.get("/api/System/Customer/SaveMan", { params }),
        delete: params => request.post("/api/System/Customer/DeleteMan", params),
    }
}

/**
 * 审核家口
 */
const audit = {
    list: params => request.post("/api/Audit/GetList", params),
    apply: params => request.post("/api/Audit/Apply", params),
    complete: params => request.post("/api/Audit/Complete", params),
    delete: params => request.get("/api/Audit/Delete", { params }),
}

export default {
    dept, staff, customer, audit
}